// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ffo7u","status":"style_status__vLawb","row":"style_row__YT7q3","row_prop":"style_row_prop__4SMyY","row_val":"style_row_val__e1HdV"};